import { type AxiosError, type AxiosInstance } from 'axios'

import routes from '@core/modules/Auth/routes'

import { authRedirectRules } from './authRedirectRules'

// ***
// HANDLE AUTH REDIRECTS
// ***

export function handleAuthRedirects() {
  const authRoutes = {
    authLogout: `${routes.basePath}${routes.routes.find((route) => route.name === 'authLogout')?.path}`,
    authLogin: `${routes.basePath}${routes.routes.find((route) => route.name === 'authLogin')?.path}`,
  }

  const {
    path,
    urlQueryParams,
    isROOT,
    notAllowedRoutes,
  } = authRedirectRules()

  const queryParams = new URLSearchParams()
  queryParams.set('expiredToken', 'true')

  if (!isROOT || !notAllowedRoutes) {
    const fromParam = urlQueryParams.get('from') || path
    queryParams.set('from', fromParam)
    queryParams.set('keepCurrentUrl', 'true')
  }

  if (!path.includes('recover') && path !== authRoutes.authLogin) {
    window.location.href = `${authRoutes.authLogout}?${queryParams.toString()}`
  }
}

// ***
// HANDLE NOT AUTHORIZED ERROR
// ***

export async function handleNotAuthorizedError(error: AxiosError, axiosInstance: AxiosInstance) {
  const axiosError = error

  if (axiosError?.response?.status === 401) {
    // Do not redirect to login if user is recovering password
    if (window.location.pathname?.includes('/password/recover')) return

    // Don't redirect if user is trying to login
    if (!axiosInstance.defaults.headers.common.Authorization) {
      if (window.location.pathname === '/auth/login') return
    }

    handleAuthRedirects()
  }
}
